export default function HTMLEntities(content) {
	content = content.replace(/&/g, '&amp;')
	content = content.replace(/</g, '&lt;')
	content = content.replace(/>/g, '&gt;')
	content = content.replace(/"/g, '&quot;')

  return content;
}
